var _defs, _path, _rect, _path2, _path3, _path4, _path5, _path6, _polygon, _path7, _path8, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogotypeOriginal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 420 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#101820;}.cls-2{fill:#ff6900;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.9,64.41V53.22H57.71V42H46.53V53.22h0V75.59A22.41,22.41,0,0,0,68.9,98V86.78A11.2,11.2,0,0,1,57.71,75.59V64.41Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 32.54,
    y: 53.22,
    width: 11.19,
    height: 11.19
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M292.36,75.59V64.41h11.19V53.22H292.36V42H281.17V53.22h0V75.59A22.41,22.41,0,0,0,303.55,98V86.78A11.2,11.2,0,0,1,292.36,75.59Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.89,98H71.7V75.59A22.4,22.4,0,0,1,94.07,53.22V64.41A11.19,11.19,0,0,0,82.89,75.59Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M362.29,98H351.1V75.59a22.4,22.4,0,0,1,22.38-22.37V64.41a11.19,11.19,0,0,0-11.19,11.18Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.25,98A22.41,22.41,0,0,1,96.87,75.59V53.22h11.19V75.59a11.19,11.19,0,0,0,22.38,0V53.22h11.18V75.59A22.4,22.4,0,0,1,119.25,98Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M278.38,98H267.19V75.59a11.19,11.19,0,0,0-22.38,0V98H233.62V75.59a22.38,22.38,0,0,1,44.76,0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "189.17 53.22 174.91 97.97 158.68 97.97 144.42 53.22 156.18 53.22 166.79 86.76 177.41 53.22 189.17 53.22"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M325.93,98A22.38,22.38,0,1,1,348.3,75.59,22.41,22.41,0,0,1,325.93,98Zm0-33.56a11.19,11.19,0,1,0,11.18,11.18A11.19,11.19,0,0,0,325.93,64.41Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.45,98a22.38,22.38,0,1,1,22.38-22.38v5.6H198.76a11.2,11.2,0,0,0,17.6,2.32l7.91,7.91A22.23,22.23,0,0,1,208.45,98Zm-9.69-28h19.38a11.19,11.19,0,0,0-19.38,0Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 376.27,
    y: 53.22,
    width: 11.19,
    height: 11.19
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotypeOriginal);
export default __webpack_public_path__ + "static/media/Logotype-Original.40105af54d6028326e1e9d36e2a42874.svg";
export { ForwardRef as ReactComponent };